<template>
    <g class="label-group"
        :class="labelClass()"
        ref="label-texts">

        <line
                v-if="hasPointer"
                :x1="labelPositionX()"
                :y1="labelPositionY()"
                :x2="labelPositionPointerX()"
                :y2="labelPositionPointerY()"
        />
        <circle
                v-if="hasPointer && selected"
                :cx="labelPositionPointerX()"
                :cy="labelPositionPointerY()"
                r="8"
                :class="{'drag':dragPointer}"
                @mousedown="startDragPointer($event)"
                @mouseup="stopDragPointer()"
                ref="label-texts-pointer"
        />
        <rect class="label-drag-rect"
              :x="labelPositionX() - textBox.width / 2 - 5"
              :y="labelPositionY() - 14"
              :width="textBox.width + 10" :height="textBox.height + 7" rx="3" ry="3"
        />
        <rect class="label-text-box"
              :x="labelPositionX() - textBox.width / 2 - 5"
              :y="labelPositionY() - 14"
              @mouseup="stopDrag()"
              :width="textBox.width + 10" :height="textBox.height + 7" rx="3" ry="3"
              ref="label-texts-box"
        />
        <text
                :x="labelPositionX() - textBox.width / 2"
                :y="labelPositionY()"
                @mouseenter="$emit('hover')"
                @mouseleave="stopDragDelay"
                @mousedown="startDrag($event)"
                @mouseup="stopDrag()"
                @click="$emit('select')"
                @dblclick.stop="$emit('edit')"
                ref="label-texts-text"
        >
            {{label.text}}
        </text>
    </g>
</template>

<script>
    import Tools from "../../class/tools";
    import events from "@/events/events";

    export default {
        name: "Texts_Pointer",
        props:{
            label:{},
            imageData:{type:Object},
            selected:{type:Boolean},
            hovered:{type:Boolean}
        },
        data(){
            return{
                start:false,
                drag:false,
                dragMove:false,
                dragPointer:false,
                dragOffset :{
                    x:0,
                    y:0
                },

                pointerCSS:"",
                textBox:{
                    width:0,
                    height:0,
                }
            }
        },
        methods:{
            startDrag($event) {
                // this.pointerStyle();
                this.start = true;
                this.dragOffset.x = $event.pageX - (this.$refs["label-texts-text"].getBoundingClientRect().left + this.textBox.width / 2);
                this.dragOffset.y = $event.pageY - (this.$refs["label-texts-text"].getBoundingClientRect().top + this.textBox.height + 3);
                setTimeout(() => {
                    if (this.start) {
                        this.drag = true;

                        this.$emit('select');
                        this.$emit('drag');
                        events.$on("body:click:mouse:up",this.stopDrag)
                    }
                }, this.$store.getters.getDelayBeforeDrag)
            },
            stopDrag() {
                this.start = false;
    
                if(this.dragMove) {
                    this.label.save();
                }
                
                this.drag = false;
                this.dragMove = false;
                this.$emit('undrag');
                events.$off("body:click:mouse:up",this.stopDrag)
            },
            stopDragDelay(){
                if(this.start && !this.drag){
                    this.start = false;
                    this.drag = false;
                }
                if(!this.drag){
                    this.$emit('unhover')
                }
            },
            startDragPointer($event){
                this.dragOffset.x = $event.pageX - (this.$refs["label-texts-pointer"].getBoundingClientRect().left + 7);
                this.dragOffset.y = $event.pageY - (this.$refs["label-texts-pointer"].getBoundingClientRect().top + 7);
                this.dragPointer = true;
                this.$emit('drag');
                events.$on("body:click:mouse:up",this.stopDragPointer)
            },
            stopDragPointer(){
                this.dragPointer = false;
                this.$emit('undrag');
    
                this.label.save();
                events.$off("body:click:mouse:up",this.stopDragPointer)
            },
            labelClass() {

                let classe = this.label.getObjectType();
                if(this.start){
                    classe += " start ";
                }
                if (this.drag) {
                    classe += " drag ";
                }
                if (this.selected) {
                    classe += " select ";
                }
                if (this.hovered) {
                    classe += " hover ";
                }

                return classe
            },
            labelPositionX(){
                let x = parseFloat(this.label.x_coord);
                x *= this.imageData.ratioX;
                return x;
            },
            labelPositionY(){
                let y = parseFloat(this.label.y_coord);
                y *= this.imageData.ratioY;
                return y;
            },
            labelPositionPointerX(){
                let x = parseFloat(this.label.pointer_x_coord);
                x *= this.imageData.ratioX;
                return x;
            },
            labelPositionPointerY(){
                let y = parseFloat(this.label.pointer_y_coord);
                y *= this.imageData.ratioY;
                return y;
            },
            lineDistance(x, y, x0, y0){
                return Math.sqrt((x -= x0) * x + (y -= y0) * y);
            },
            getLengthText(){
                return {
                    width:this.$refs['label-texts-text'].getBoundingClientRect().width,
                    height:this.$refs['label-texts-text'].getBoundingClientRect().height,
                }
            }
        },
        computed:{
            hasPointer(){
                return (this.label.pointer_x_coord != 0 && this.label.pointer_x_coord != null) && (this.label.pointer_y_coord != 0 && this.label.pointer_y_coord != null);
            }
        },
        watch:{
            '$store.state.mouse.position'(value){

                let label = this.label;

                // drag text
                if (this.drag) {
                    label.x_coord = Tools.format(value.x - this.dragOffset.x,-100, this.imageData.width + 100,this.imageData.ratioX);
                    label.y_coord = Tools.format(value.y - this.dragOffset.y,-1000, this.imageData.height + 1000,this.imageData.ratioY);
                    
                    if(this.hasPointer){
                        if(label.pointer_x_coord > label.x_coord - 10 && label.pointer_x_coord < Number(label.x_coord) + 10){
                            label.x_coord = label.pointer_x_coord
                        }
                        if(label.pointer_y_coord > label.y_coord - 10 && label.pointer_y_coord < Number(label.y_coord) + 10){
                            label.y_coord = label.pointer_y_coord
                        }
                    }
                    
                    this.dragMove = true
                }

                // drag pointer
                if(this.dragPointer){
                    label.pointer_x_coord = Tools.format(value.x - this.dragOffset.x,1, this.imageData.width,this.imageData.ratioX);
                    label.pointer_y_coord = Tools.format(value.y - this.dragOffset.y,1, this.imageData.height,this.imageData.ratioY);
    
                    if(label.pointer_x_coord > label.x_coord - 10 && label.pointer_x_coord < Number(label.x_coord) + 10){
                        label.pointer_x_coord = label.x_coord
                    }
                    if(label.pointer_y_coord > label.y_coord - 10 && label.pointer_y_coord < Number(label.y_coord) + 10){
                        label.pointer_y_coord = label.y_coord
                    }
                }
            },
            'label.text'() {
                setTimeout(() => {
                    this.textBox = this.getLengthText();
                })
            },
            'imageData.zoom'(){
                this.$forceUpdate();
            },
            'imageData.width'(){
                this.$forceUpdate();
            },
            'imageData.height'(){
                this.$forceUpdate();
            },
        },
        mounted() {
            // this.pointerStyle();
            this.textBox = this.getLengthText();
        }
    }
</script>